import React from 'react';
import '../AddReferralModal/AddReferral.css';
import { MdCancel } from 'react-icons/md';
import { FaCarSide } from "react-icons/fa";
import { AddReferralModalLogic } from './AddReferralModalLogic';
import CustomDropdown from './CustomDropdown';
import { FaBuildingColumns, FaLocationDot } from 'react-icons/fa6';
import { FiUser } from 'react-icons/fi';
import { PiNotePencilBold } from "react-icons/pi";
import { LuFiles } from "react-icons/lu";

const AddReferralModal = ({ onClose, onSave, onSubmit }) => {

  const {
    handleSubmit,
    title,
    users,
    customMake,
    accessLevel,
    customCounty,
    isDragging,
    formData,
    iscountyOther,
    customYear,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    handleChange,
    isOtherSelected,
    isYearOther,
    setCustomMake,
    setCustomYear,
    setTittle,
    errors,
    setcustomCounty,
    setFormData,
    handleFileSelection,
    handleKeyDown,
    Years,
    VechileMakes,
    countyOptions

  } = AddReferralModalLogic({ onClose, onSave, onSubmit });
  return (
    <div className="modal-overlay">
      <div className="modal-content-photolibrary">
        <div className="modal-header">
          <span className="modal-title">Add Referral</span>
          <MdCancel className="close-modal" size={24} onClick={onClose} />
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit} className="referral-form">
            {/* PERSONAL INFO */}
            <fieldset>
              <div className="legend-with-dropdown ">
                <legend><FiUser size={18} /> Personal Information</legend>
                {(accessLevel === 2 || accessLevel === 3) && (
                  <div className="form-group-title-dropdown">
                    <label htmlFor="title">Attorney</label>
                    <select
                      id="title"
                      name="title"
                      value={title}
                      class="form-control"
                      onChange={(e) => setTittle(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Select Attorney</option>
                      {users.map((attorney) => (
                        <option key={attorney.username} value={attorney.username}>
                          {attorney.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

              </div>
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="firstName">First Name *</label>
                  <input id="firstName" value={formData.firstName}
                    onChange={handleChange} class="form-control" required name="firstName" type="text" />
                  {errors.firstName && <span className="error-text">{errors.firstName}</span>}
                </div>
                <div className="form-group form-group-referral">
                  <label htmlFor="middleName">Middle Initial</label>
                  <input id="middleName" class="form-control" value={formData.middleName}
                    onChange={handleChange} name="middleName" type="text" />
                </div>
                <div className="form-group form-group-referral">
                  <label htmlFor="lastName">Last Name </label>
                  <input id="lastName" class="form-control" value={formData.lastName}
                    onChange={handleChange} name="lastName" type="text" />
                </div>
              </div>

              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="email">Email *</label>
                  <input id="email" class="form-control" value={formData.email}
                    onChange={handleChange} required name="email" type="email" />
                  {errors.email && <span className="error-text">{errors.email}</span>}
                </div>
                <div className="form-group form-group-referral">
                  <label htmlFor="phoneNumber">Phone *</label>
                  <input required class="form-control" value={formData.phoneNumber}
                    onChange={handleChange} id="phoneNumber" name="phoneNumber" type="number"
                    onKeyDown={handleKeyDown}
                  />
                  {errors.phoneNumber && <span className="error-text">{errors.phoneNumber}</span>}

                </div>
                <div className="form-group form-group-referral">
                  <label htmlFor="emergencyPhone">Emergency Phone </label>
                  <input id="emergencyPhone" class="form-control" value={formData.emergencyPhone}
                    onChange={handleChange} name="emergencyPhone" type="number"
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>

              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral dob-responsive">
                  <label htmlFor="dob">Date of Birth </label>
                  <input
                    className="form-control"
                    id="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    name="dob"
                    type="date"
                    max={new Date().toISOString().split("T")[0]} // Prevents future dates
                  />
                </div>
              </div>


            </fieldset>

            {/* ADDRESS INFO */}
            <fieldset>
              <legend><FaLocationDot size={18} /> Address Information</legend>
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="address"
                  >Address </label>
                  <input id="address" class="form-control" onChange={handleChange} value={formData.address} name="address" type="text" />
                </div>
              </div>
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="city">City </label>
                  <input className="form-control" id="city" value={formData.city}
                    onChange={handleChange} name="city" type="text" />
                </div>
                <div className="form-group form-group-referral">
                  <CustomDropdown
                    label="County"
                    name="county"
                    options={countyOptions}
                    value={formData.county}
                    onChange={handleChange}
                    placeholder="Select County"
                  />

                </div>
                {iscountyOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="county">Enter County</label>
                    <input
                      className="form-control" id="customCounty"
                      onChange={(e) => setcustomCounty(e.target.value)} name="customCounty" type="text" value={customCounty}
                    />
                  </div>
                )}
                {!iscountyOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="state">State </label>

                    <input className="form-control" id="state" value={formData.state}
                      onChange={handleChange} name="state" type="text" />
                  </div>
                )}
              </div>
              <div className="form-row form-row-referral">
                {iscountyOther && (
                  <div className="form-group form-group-referral dob-responsive">
                    <label htmlFor="state">State </label>

                    <input className="form-control" id="state" value={formData.state}
                      onChange={handleChange} name="state" type="text" />
                  </div>
                )}
                <div className="form-group form-group-referral dob-responsive">
                  <label htmlFor="zip" >ZIP Code </label>
                  <input className="form-control" id="zip" value={formData.zip}
                    onChange={handleChange} name="zip" type="text" />
                </div>
              </div>
            </fieldset>



            <fieldset>
              <legend><FaCarSide size={18} /> Vehicle Information</legend>

              {/* Row 1 */}
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <CustomDropdown
                    label="Vehicle Make"
                    className="form-control form-row-referral-1"
                    name="vehicleMake"   // corrected name here
                    options={VechileMakes}
                    value={formData.vehicleMake}
                    placeholder="Vehicle Make"
                    onChange={handleChange}
                  />
                </div>

                {isOtherSelected && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="customMake">Enter Make</label>
                    <input
                      className="form-control"
                      id="customMake"
                      name="customMake"
                      type="text"
                      value={customMake}
                      onChange={(e) => setCustomMake(e.target.value)}
                    />
                  </div>
                )}

                <div className="form-group form-group-referral">
                  <label htmlFor="vehicleModel">Vehicle Model</label>
                  <input className="form-control" value={formData.vehicleModel}
                    onChange={handleChange} id="vehicleModel" name="vehicleModel" type="text" />
                </div>

                {!isOtherSelected && (
                  <div className="form-group form-group-referral">
                    <CustomDropdown
                      label="Vehicle Year"
                      className="form-control form-row-referral-1"
                      name="vehicleYear"
                      options={Years}
                      value={formData.vehicleYear}
                      placeholder="Vehicle Year"
                      onChange={handleChange}

                    />
                  </div>
                )}
              </div>

              {/* Row 2 */}
              <div className="form-row form-row-referral">
                {isOtherSelected && (
                  <div className="form-group form-group-referral">
                    <CustomDropdown
                      label="Vehicle Year"
                      className="form-control form-row-referral-1"
                      name="vehicleYear"
                      options={Years}
                      value={formData.vehicleYear}
                      placeholder="Vehicle Year"
                      onChange={handleChange}
                    />
                  </div>

                )}
                {isYearOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="customYear">Enter year</label>
                    <input
                      className="form-control"
                      id="customYear"
                      name="customYear"
                      type="number"
                      value={customYear}
                      onChange={(e) => setCustomYear(e.target.value)}
                    />
                  </div>
                )}

                <div className="form-group form-group-referral">
                  <label htmlFor="vehicleColor">Vehicle Color</label>
                  <input id="vehicleColor" value={formData.vehicleColor}
                    className="form-control" onChange={handleChange} name="vehicleColor" type="text" />
                </div>

                {!isOtherSelected && isYearOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="ignitionType">Ignition Type</label>
                    <select id="ignitionType" name="ignitionType"
                      className="form-control"
                      value={formData.ignitionType}
                      onChange={handleChange}>
                      <option value="">Select ignition type</option>
                      <option value="key">Key</option>
                      <option value="push-button">Push Button</option>
                    </select>
                  </div>
                )}

                {!isOtherSelected && !isYearOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="ignitionType">Ignition Type</label>
                    <select id="ignitionType" name="ignitionType"
                      className="form-control"
                      value={formData.ignitionType}
                      onChange={handleChange}>
                      <option value="">Select ignition type</option>
                      <option value="key">Key</option>
                      <option value="push-button">Push Button</option>
                    </select>
                  </div>
                )}

                {!isYearOther && isOtherSelected && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="ignitionType">Ignition Type</label>
                    <select id="ignitionType" name="ignitionType"
                      className="form-control"
                      value={formData.ignitionType}
                      onChange={handleChange}>
                      <option value="">Select ignition type</option>
                      <option value="key">Key</option>
                      <option value="push-button">Push Button</option>
                    </select>
                  </div>
                )}


                {!isYearOther && !isOtherSelected && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="vin">VIN</label>
                    <input value={formData.vin}
                      className="form-control"
                      onChange={handleChange} id="vin" name="vin" type="text" />
                  </div>
                )}

              </div>

              {/* Row 3 */}
              <div className="form-row form-row-referral">


                {isOtherSelected && isYearOther && (
                  <div className="form-group form-group-referral">
                    <label htmlFor="ignitionType">Ignition Type</label>
                    <select id="ignitionType" name="ignitionType"
                      className="form-control"
                      value={formData.ignitionType}
                      onChange={handleChange}>
                      <option value="">Select ignition type</option>
                      <option value="key">Key</option>
                      <option value="push-button">Push Button</option>
                    </select>
                  </div>
                )}

                {isYearOther && !isOtherSelected && (
                  <div className="form-group form-group-referral ">
                    <label htmlFor="vin">VIN</label>
                    <input id="vin" className="form-control" value={formData.vin}
                      onChange={handleChange} name="vin" type="text" />
                  </div>
                )}
                {isYearOther && !isOtherSelected && (
                  <div className="form-row form-row-referral dob-responsive">
                    <div className="form-group form-group-referral ">
                      <label htmlFor="licensePlate">License Plate</label>
                      <input className="form-control" value={formData.licensePlate}
                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                    </div>
                  </div>
                )}
                {isOtherSelected && (
                  <div className="form-group form-group-referral ">
                    <label htmlFor="vin">VIN</label>
                    <input id="vin" className="form-control" value={formData.vin}
                      onChange={handleChange} name="vin" type="text" />
                  </div>
                )}
                {isOtherSelected && (
                  <div className="form-group form-group-referral dob-responsive">
                    <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                    <input className="form-control" value={formData.DriverlicenseNumber}
                      onChange={handleChange} id="DriverlicenseNumber" name="DriverlicenseNumber" type="text" />
                  </div>
                )}
                {isOtherSelected && !isYearOther && (
                  <div className="form-row form-row-referral dob-responsive">
                    <div className="form-group form-group-referral ">
                      <label htmlFor="licensePlate">License Plate</label>
                      <input className="form-control" value={formData.licensePlate}
                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                    </div>
                  </div>
                )}


                {!isOtherSelected && !isYearOther && (
                  <div className="form-group form-group-referral dob-responsive">
                    <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                    <input className="form-control" value={formData.DriverlicenseNumber}
                      onChange={handleChange} id="DriverlicenseNumber" name="DriverlicenseNumber" type="text" />
                  </div>
                )}
                {!isOtherSelected && isYearOther && (
                  <div className="form-group form-group-referral dob-responsive">
                    <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                    <input className="form-control" value={formData.DriverlicenseNumber}
                      onChange={handleChange} id="DriverlicenseNumber" name="DriverlicenseNumber" type="text" />
                  </div>
                )}
                {!isOtherSelected && !isYearOther && (
                  <div className="form-row form-row-referral dob-responsive">
                    <div className="form-group form-group-referral ">
                      <label htmlFor="licensePlate">License Plate</label>
                      <input className="form-control" value={formData.licensePlate}
                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                    </div>
                  </div>
                )}

              </div>
              <div className="form-row form-row-referral">
                {isYearOther && isOtherSelected && (
                  <div className="form-row form-row-referral dob-responsive">
                    <div className="form-group form-group-referral ">
                      <label htmlFor="licensePlate">License Plate</label>
                      <input className="form-control" value={formData.licensePlate}
                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                    </div>
                  </div>
                )}
              </div>
            </fieldset>

            <fieldset>
              <legend><FaBuildingColumns size={16} /> Court Information</legend>

              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="courtName">Court Name</label>
                  <input id="courtName" value={formData.courtName} className="form-control"
                    onChange={handleChange} name="courtName" type="text" placeholder="Court Name" />
                </div>
              </div>
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <label htmlFor="courtAddress">Court Address</label>
                  <input id="courtAddress" value={formData.courtAddress} className="form-control"
                    onChange={handleChange} name="courtAddress" type="text" placeholder="Court Adress" />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend><PiNotePencilBold size={19} />Notes</legend>

              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral">
                  <textarea
                    id="notes"
                    name="notes"
                    placeholder="Enter notes separted by comma... "
                    maxLength={1000}
                    className="form-control"
                    multiple
                    webkitdirectory="true" // <-- Enables folder selection in WebKit browsers (Chrome, Safari, Edge)
                    directory="true"
                    value={Array.isArray(formData.notes) ? formData.notes.join('\n') : formData.notes}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        notes: value.split('\n').filter((line) => line.trim() !== ''),
                      });
                    }}
                  />

                  <div className="char-limit-text">Max 1000 characters</div>
                </div>
              </div>


            </fieldset>
            <fieldset>
              <legend><LuFiles size={20} />Files</legend>
              <div className="form-row form-row-referral">
                <div className="form-group form-group-referral upload-box">
                  <div className={`upload-box-content ${isDragging ? 'dragging' : ''}`}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}>
                    <p>{isDragging ? "Drop files here..." : "Please select or drag files here"}</p>
                    <input
                      id="files"
                      name="files"
                      type="file"
                      className='form-control form-control-div'
                      multiple
                      onChange={handleFileSelection}
                    />
                    {/* {selectedFiles.length > 0 && (
                      <div className="selected-files-list mt-2">
                        <h6>Selected Files:</h6>
                        <ul>
                          {selectedFiles.map((file, index) => (
                            <li key={index}>
                              {file.name} ({Math.round(file.size / 1024)} KB)
                              <button
                                type="button"
                                className="btn btn-sm btn-danger ml-2"
                                onClick={() => setSelectedFiles(prev => prev.filter((_, i) => i !== index))}
                              >
                                Remove
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </fieldset>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddReferralModal;